/**
 * @flow
 * @relayHash 8b67a718422e98c4a714ccc0bd2dff88
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HttpWithinHttpsTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type HttpWithinHttpsTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  assetTypeFilters?: ?$ReadOnlyArray<?string>,
  typeFilters?: ?$ReadOnlyArray<?string>,
  sourceUrl?: ?TextFilters,
  assetUrl?: ?TextFilters,
|};
export type HttpWithinHttpsTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: HttpWithinHttpsTable_project$ref
  |}
|};
export type HttpWithinHttpsTable_RefetchQuery = {|
  variables: HttpWithinHttpsTable_RefetchQueryVariables,
  response: HttpWithinHttpsTable_RefetchQueryResponse,
|};
*/


/*
query HttpWithinHttpsTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $assetTypeFilters: [String]
  $typeFilters: [String]
  $sourceUrl: TextFilters
  $assetUrl: TextFilters
) {
  project(host: $host) {
    ...HttpWithinHttpsTable_project_2AApnZ
    id
  }
}

fragment HttpWithinHttpsTable_project_2AApnZ on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesHttpInHttps(assetTypeFilters: $assetTypeFilters, assetUrl: $assetUrl, sourceUrl: $sourceUrl) {
          type
          severity
          count
        }
        httpInHttps(offset: $offset, limit: $limit, typeFilters: $typeFilters, assetTypeFilters: $assetTypeFilters, assetUrl: $assetUrl, sourceUrl: $sourceUrl) {
          count
          edges {
            node {
              ...HttpWithinHttpsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment HttpWithinHttpsRow_issue on HttpInHttps {
  id
  type
  severity
  asset_count
  asset_types
  asset_urls
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "assetTypeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "assetUrl",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "assetTypeFilters",
  "variableName": "assetTypeFilters",
  "type": "[String]"
},
v3 = {
  "kind": "Variable",
  "name": "assetUrl",
  "variableName": "assetUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HttpWithinHttpsTable_RefetchQuery",
  "id": null,
  "text": "query HttpWithinHttpsTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $assetTypeFilters: [String]\n  $typeFilters: [String]\n  $sourceUrl: TextFilters\n  $assetUrl: TextFilters\n) {\n  project(host: $host) {\n    ...HttpWithinHttpsTable_project_2AApnZ\n    id\n  }\n}\n\nfragment HttpWithinHttpsTable_project_2AApnZ on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesHttpInHttps(assetTypeFilters: $assetTypeFilters, assetUrl: $assetUrl, sourceUrl: $sourceUrl) {\n          type\n          severity\n          count\n        }\n        httpInHttps(offset: $offset, limit: $limit, typeFilters: $typeFilters, assetTypeFilters: $assetTypeFilters, assetUrl: $assetUrl, sourceUrl: $sourceUrl) {\n          count\n          edges {\n            node {\n              ...HttpWithinHttpsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment HttpWithinHttpsRow_issue on HttpInHttps {\n  id\n  type\n  severity\n  asset_count\n  asset_types\n  asset_urls\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HttpWithinHttpsTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HttpWithinHttpsTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "assetTypeFilters",
                "variableName": "assetTypeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "assetUrl",
                "variableName": "assetUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HttpWithinHttpsTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesHttpInHttps",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3,
                          v4
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v5,
                          v6,
                          v7
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "httpInHttps",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3,
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v4,
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "HttpInHttpssConnection",
                        "plural": false,
                        "selections": [
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "HttpInHttpssEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "HttpInHttps",
                                "plural": false,
                                "selections": [
                                  v8,
                                  v5,
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "asset_count",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "asset_types",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "asset_urls",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v8
                    ]
                  }
                ]
              }
            ]
          },
          v8
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eb9bf3eddf25aec20b105ef0e5785f37';
module.exports = node;
